import { ProductPriceTierDerivationType } from "@sellar-io/api-v2/types";
import { create } from "zustand";

type ProductId = number;
export type PriceListPricingMap = Record<
  ProductId,
  {
    productId: number;
    priceTierId?: number;
    productPriceTierId?: number;
    derivationType: ProductPriceTierDerivationType;
    derivationValue: number | null;
    basePrice: number | null;
    price: number | null;
    discountable: boolean;
    updated: boolean;
  }
>;

type State = {
  priceListPricingMap: PriceListPricingMap;
  setPriceListPricingMap: (map: PriceListPricingMap) => void;
  updatePrice: (parameters: {
    productId: number;
    derivationType?: ProductPriceTierDerivationType;
    derivationValue?: number | null;
    basePrice?: number | null;
    price?: number | null;
    discountable?: boolean;
    updated?: boolean;
  }) => void;
  clearUpdatedFlags: () => void;
};

export const usePriceListStore = create<State>((set, get) => ({
  priceListPricingMap: {},
  setPriceListPricingMap: (map) => set({ priceListPricingMap: map }),
  updatePrice: ({
    productId,
    derivationType,
    derivationValue,
    basePrice,
    price,
    discountable,
    updated,
  }) => {
    const map = { ...get().priceListPricingMap };
    map[productId] = {
      ...map[productId],
      productId,
      derivationType:
        derivationType !== undefined
          ? derivationType
          : (map[productId]?.derivationType ?? "none"),
      derivationValue:
        derivationValue !== undefined
          ? derivationValue
          : (map[productId]?.derivationValue ?? null),
      basePrice:
        basePrice !== undefined
          ? basePrice
          : (map[productId]?.basePrice ?? null),
      price: price !== undefined ? price : (map[productId]?.price ?? null),
      discountable:
        discountable !== undefined
          ? discountable
          : (map[productId]?.discountable ?? true),
      updated: updated ?? true,
    };
    set({ priceListPricingMap: map });
  },
  clearUpdatedFlags: () => {
    const map = Object.fromEntries(
      Object.entries(get().priceListPricingMap).map(([key, value]) => [
        key,
        { ...value, updated: false },
      ]),
    );

    set({ priceListPricingMap: map });
  },
}));
